import React, { useState } from 'react';
import './Pricing.css';

const pricingData = {
  quarterly: {
    starter: {
      price: 2697,
      badge: 'STARTER',
      color: '#0191c6'
    },
    professional: {
      price: 10797,
      badge: 'PROFESSIONAL',
      color: '#0191c6'
    },
    enterprise: {
      price: 26997,
      badge: 'ENTERPRISE',
      color: '#0191c6'
    }
  },
  annually: {
    starter: {
      price: 9590,
      badge: 'STARTER',
      color: '#0191c6'
    },
    professional: {
      price: 38390,
      badge: 'PROFESSIONAL',
      color: '#0191c6'
    },
    enterprise: {
      price: 95990,
      badge: 'ENTERPRISE',
      color: '#0191c6'
    }
  }
};

const features = {
  starter: [
    'Upto 10 appoinments',
    'Real time transcription',
    'Limited language support',
    'Access to only web',
    'Limited patients record'
  ],
  professional: [
    'Everything including basics',
    'Unlimited appointments',
    'Advanced analytics',
    'Access to mobile and web',
    'Unlimited language support',
    'Automatic language support'
  ],
  enterprise: [
    'Everything including professional',
    'Custom reporting',
    'Advanced Patient Management',
    'Machine Learning Insights',
    'Dedicated account manager',
    'Automated generate prescription',
    'Advanced recommendation system'
  ]
};

const Pricing = () => {
  const [billingCycle, setBillingCycle] = useState('quarterly');

  const handleBillingChange = (cycle) => {
    setBillingCycle(cycle);
  };

  return (
    <section className="pricing-section">
      <div className="pricing-container">
        <h2 style={{textAlign: 'center', fontSize: '2.3rem', fontWeight: 700, marginBottom: 40}}>
          Explore Genix <span style={{color: '#0098d0', fontWeight: 700}}>most popular</span><br />packages
        </h2>
        
        {/* Billing Cycle Tabs */}
        <div className="billing-tabs">
          <button 
            className={`tab ${billingCycle === 'quarterly' ? 'active' : ''}`}
            onClick={() => handleBillingChange('quarterly')}
          >
            Quarterly
          </button>
          <button 
            className={`tab ${billingCycle === 'annually' ? 'active' : ''}`}
            onClick={() => handleBillingChange('annually')}
          >
            Annually
          </button>
        </div>

        {/* Pricing Cards */}
        <div className="pricing-cards">
          {/* Starter Plan */}
          <div className="pricing-card">
            <div className="plan-badge">
              {pricingData[billingCycle].starter.badge}
            </div>
            <div className="price">
              <span className="currency">Rs.</span>
              <span className="amount">{pricingData[billingCycle].starter.price}</span>
              <span className="period">/{billingCycle === 'quarterly' ? 'quarter' : 'year'}</span>
            </div>
            <ul className="features">
              {features.starter.map((feature, index) => (
                <li key={index}>
                  <svg className="checkmark" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
            <button className="cta-button">
              Get Started
              <svg className="arrow" viewBox="0 0 24 24">
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
              </svg>
            </button>
          </div>

          {/* Professional Plan */}
          <div className="pricing-card popular">
            <div className="popular-ribbon">POPULAR</div>
            <div className="plan-badge">
              {pricingData[billingCycle].professional.badge}
            </div>
            <div className="price">
              <span className="currency">Rs.</span>
              <span className="amount">{pricingData[billingCycle].professional.price}</span>
              <span className="period">/{billingCycle === 'quarterly' ? 'quarter' : 'year'}</span>
            </div>
            <ul className="features">
              {features.professional.map((feature, index) => (
                <li key={index}>
                  <svg className="checkmark" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
            <button className="cta-button">
              Get Advanced
              <svg className="arrow" viewBox="0 0 24 24">
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
              </svg>
            </button>
          </div>

          {/* Enterprise Plan */}
          <div className="pricing-card">
            <div className="plan-badge">
              {pricingData[billingCycle].enterprise.badge}
            </div>
            <div className="price">
              <span className="currency">Rs.</span>
              <span className="amount">{pricingData[billingCycle].enterprise.price}</span>
              <span className="period">/{billingCycle === 'quarterly' ? 'quarter' : 'year'}</span>
            </div>
            <ul className="features">
              {features.enterprise.map((feature, index) => (
                <li key={index}>
                  <svg className="checkmark" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
            <button className="cta-button">
              Get Pro
              <svg className="arrow" viewBox="0 0 24 24">
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing; 